/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
import React from 'react'
// import { useOnClickOutside } from '../../CommonMethods/OutsideClick'
export default function FilterModal({ isFilterOpen, setIsFilterOpen, handleApplyFilter, initialState, filterValues, setFilterValues, handleOpenFilter, handleCheckboxChange }) {


    return (
        <div className='relative ml-2.5 2xl:mb-0 mb-2.5'>
            <button id='filter' type='button' className='flex items-center min-w-max border border-[#972E4C] rounded-[15px] px-4 py-2' onClick={handleOpenFilter}>
                <img src="/images/filter_icon.svg" alt="icon" />
                <span className='text-lg font-semibold text-[#972E4C] ml-2.5'>Filter</span>
            </button>
            {
                isFilterOpen &&
                // <motion.div
                //     initial={{ opacity: 0, x: 80,y:-46 }}
                //     animate={{ opacity: 1, x: 0 ,y:-46}}
                //     transition={{ delay: 0.2, duration: 0.5 }}
                //     exit={{ opacity: 0.5 }}
                //     className='z-[999] bg-white'
                // >
                <div className='absolute top-14 right-0 bg-white rounded-[15px] border border-[#D296B2] pl-[20px] pr-[27px] pt-4 py-[26px] shadow-s2 w-[225px] z-[2]'>
                    <div className='flex justify-between items-center mb-4'>
                        <p className='text-sm font-semibold text-[#52555D]'>Filter by:</p>
                        <button type='button' className='absolute right-[16px]' onClick={() => { setIsFilterOpen(!isFilterOpen), setFilterValues(initialState) }}>
                            <img src="/images/cross_mark_gray.svg" alt="icon" />
                        </button>
                    </div>
                    <div className='flex flex-wrap -mx-2 justify-between items-center mb-4'>
                        <p className='text-[12px] pl-2 font-semibold text-[#000]'>Provider Credentials</p>
                        {Object.values(filterValues).some(value => value.length > 0) && (
                            <p
                                id='clear_all'
                                onClick={() => {
                                    handleApplyFilter(false);
                                    setFilterValues(initialState);
                                    setIsFilterOpen(false);
                                }}
                                className='text-[12px] font-semibold text-[#972E4C] cursor-pointer'
                            >
                                Clear All
                            </p>
                        )}
                    </div>
                    <div className="">
                        <div className='p-[8px] flex items-center cursor-pointer mb-4 mark-check  relative checkbox custom-checkBoxBlue1'>
                            <input
                                type='checkbox'
                                id='Nurse'
                                onChange={(e) => handleCheckboxChange(e, 'provider_credential')}
                                checked={filterValues && filterValues.provider_credential && filterValues.provider_credential.includes('Nurse')}
                                className='h-[18px] w-[18px]'
                            />                            
                            <label htmlFor='Nurse' className='text-[16px] cursor-pointer font-normal text-[#000] ml-[16px]'>Nurse</label>
                        </div>
                        <div className='p-[8px] cursor-pointer flex items-center mb-4 relative mark-check checkbox custom-checkBoxBlue1'>
                            <input
                                type='checkbox'
                                id='Physician'
                                onChange={(e) => handleCheckboxChange(e, 'provider_credential')}
                                checked={filterValues && filterValues.provider_credential && filterValues.provider_credential.includes('Physician')}
                                className='h-[18px] w-[18px]'
                            />
                            <label htmlFor='Physician' className='text-[16px] font-normal cursor-pointer text-[#000] ml-[16px]'>Physician</label>
                        </div>
                        <hr />
                        <p className='text-[12px] font-semibold text-[#000] mt-4 mb-4'>Status</p>
                        <div className='p-[8px] cursor-pointer flex items-center mb-4 relative mark-check  checkbox custom-checkBoxBlue1'>
                            <input
                                type='checkbox'
                                id='active'
                                onChange={(e) => handleCheckboxChange(e, 'status')}
                                checked={filterValues && filterValues.status && filterValues.status.includes('active')}
                                className='h-[18px] w-[18px]'
                            />
                            <label id='active' htmlFor='active' className='text-[16px] cursor-pointer font-normal text-[#000] ml-[16px]'>Active</label>
                        </div>
                        <div className='p-[8px] cursor-pointer flex items-center mb-4 mark-check  relative checkbox custom-checkBoxBlue1'>
                            <input
                                type='checkbox'
                                id='inactive'
                                onChange={(e) => handleCheckboxChange(e, 'status')}
                                checked={filterValues && filterValues.status && filterValues.status.includes('inactive')}
                                className='h-[18px] w-[18px]'
                            />
                            <label id='inactive' htmlFor='inactive' className='text-[16px] cursor-pointer font-normal text-[#000] ml-[16px]'>Inactive</label>
                        </div>
                        <hr className='mb-4'/>
                        <button
                            id='apply-filter'
                            onClick={() => {
                                handleApplyFilter(true), setIsFilterOpen(false);
                            }}
                            type='button'
                            disabled={
                                !filterValues ||
                            !Object.values(filterValues).some(
                                (value) => Array.isArray(value) && value.length > 0
                            )
                            }
                            className={`py-2.5 px-4 rounded-[16px] ${
                                !filterValues ||
                                !Object.values(filterValues).some(
                                    (value) => Array.isArray(value) && value.length > 0
                                )
                                    ? 'bg-[#777C88] cursor-not-allowed'
                                    : 'bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] border border-[#972E4C]'
                            } w-full text-lg font-semibold text-[#FFFFFF] hover:duration-75 reset_password_conf`}
                        >
                            Apply
                        </button>
                    </div>
                </div>
                // </motion.div>
            }
        </div>
    )
}
